export class Reference {
	static deserialize(serialized : Reference.ISerialized) {
		return new this(serialized.value);
	};

	readonly value : string;

	serialize() : Reference.ISerialized {
		return {
			value : this.value
		};
	};

	constructor(value : string) {
		this.value = value;
	};
};
export namespace Reference {
	export interface ISerialized {
		value : string;
	};
}
